export default {
  state: {
    activeProgram: undefined,
    programStatuses: {
      inactive: 0,
      active: 1,
      deactivated: 2,
      ended: 3,
    },
    programTypes: {
      goalOriented: 1,
      sequential: 2,
      selfMentorship: 3,
    },
  },
};
